import React from "react";
import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Container, Typography, Box } from "@mui/material"
import BgContainer2 from "./CommonC/BgContainer2";
import SelexSolNavbar from "./CommonC/SelexSolNavbar";
import { Paper } from "@mui/material";
import { baseURL } from "../Config/config";
import GlobalLoader from "./CommonC/GlobalLoader";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import { IconButton } from "@mui/material";
import { TextField, Button } from "@mui/material"

import Projectcolors from "../Utils/Colors";


const stylec = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  height: 480,
  bgcolor: "white",
  border: "0px solid #000",
  p: 4,
  display: "block",
};


function ProjectsPreview(){
    const navigate = useNavigate()
    
    const handleOpenc = () => setOpenc(true);
    const handleOpen = () => setOpen(true);
    const [openc, setOpenc] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [project, setProject] = React.useState({});
      const handleClosec = () => setOpenc(false);
      const [loader, setLoader] = React.useState(false);
      const [comments,setComments] = useState([])
const [name,setName] = useState("")
const [email,setEmail] = useState("")
const [comment,setComment] = useState("")
const [replyText, setReplyText] = useState("")
const [replyName, setReplyName] = useState("")

const [activeReply, setActiveReply] = useState(null)



      

const {slug} = useParams()
const shareUrl = `https://selexsuite.com/projects/${slug}?v=${Date.now()}`;
console.log(slug)
useEffect(async () => {
    await displayProjects();
    await getComments();
  }, []);
  const getComments = async ()=>{

let res = await fetch(`${baseURL}/getoptimizeprojectscomments/${slug}`)
res = await res.json()

setComments(res.comments)

}
const submitReply = async (commentId) => {

  if(!replyText){
    alert("Reply cannot be empty")
    return
  }

  try{
    const today = new Date().toISOString().split("T")[0];
    const requestOptions = {
      method:"POST",
      headers:{
        "Content-Type":"application/json"
      },
      body: JSON.stringify({
        comment_id: commentId,
        name: replyName,
        comment: replyText,
        date:today
      })
    }

    let res = await fetch(`${baseURL}/replyoptimizeprojectscomment`,requestOptions)
    res = await res.json()

    if(res.status === "success"){
      setReplyText("")
      setActiveReply(null)
      getComments()
    }

  }catch(error){
    console.log(error)
  }

}


const displayProjects = async ()=>{
    setLoader(true)

  const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(slug),
      };
      try {
        let res = await fetch(`${baseURL}/displayoptimizeproject`, requestOptions);
        res = await res.json();
        console.log(res)
        setProject(res['project'])
        setLoader(false)
       
      } catch (error) {
        setLoader(false)

        alert("Some Error", error);
        console.log("err", error);
      }

}

const addComment = async () => {

  if (!name || !email || !comment) {
    alert("Please fill all fields")
    return
  }

  try {
    const today = new Date().toISOString().split("T")[0];
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        slug: slug,
        name: name,
        email: email,
        comment: comment,
         date: today
      })
    }

    let res = await fetch(`${baseURL}/addoptimizeprojectscomment`, requestOptions)
    res = await res.json()

    if (res.status === "success") {

      // reload comments from DB
      getComments()

      // clear form
      setName("")
      setEmail("")
      setComment("")
    }

  } catch (error) {
    console.log("Comment error", error)
    alert("Error adding comment")
  }

}

const likeComment = async (commentId) => {

  try {

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        comment_id: commentId
      }),
    };

    let res = await fetch(`${baseURL}/likeoptimizeprojectscomment`, requestOptions);
    res = await res.json();

    if(res.status === "liked"){
      getComments(); // reload comments to update like count
    }

  } catch (error) {
    console.log("Like error", error);
  }

};


return (
  <Box
    sx={{
      minHeight: "100vh",
      background:
        "radial-gradient(circle at 8% 10%, rgba(0,120,201,0.08), transparent 28%), radial-gradient(circle at 90% 12%, rgba(158,11,34,0.07), transparent 25%), #fff",
      overflowX: "hidden",
    }}
  >
   <SelexSolNavbar isLoggedIn={!!sessionStorage.getItem("usertoken")}/>

    <Container maxWidth="lg" sx={{ pt: { xs: 2, md: 4 }, pb: 7 }}>
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Typography
          sx={{
            color: "#9e0b22",
            fontSize: 12,
            fontWeight: 950,
            letterSpacing: 1.4,
            textTransform: "uppercase",
            mb: 1,
          }}
        >
          Project Case Study
        </Typography>

        <Typography
          sx={{
            fontSize: { xs: 22, md: 44 },
            fontWeight: 950,
            color: "#0078C9",
            letterSpacing: "-1.8px",
            lineHeight: 1.08,
            mb: 2,
          }}
        >
          {project.title}
        </Typography>

        <Typography sx={{ color: "#64748b", fontSize: 14, fontWeight: 700 }}>
          By {project.author}
        </Typography>
      </Box>

      <Box
        sx={{
          position: "relative",
          borderRadius: "34px",
          overflow: "hidden",
          boxShadow: "0 24px 70px rgba(6,29,52,0.16)",
          mb: 4,
        }}
      >
        <Box
          component="img"
          src={project.image}
          alt={project.title}
          sx={{
            width: "100%",
            height: { xs: 260, md: 460 },
            objectFit: "cover",
            display: "block",
          }}
        />

        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(to top, rgba(6,29,52,0.72), transparent 60%)",
          }}
        />

        <Box
          sx={{
            position: "absolute",
            bottom: 24,
            left: 24,
            bgcolor: "#fff",
            color: "#9e0b22",
            px: 2,
            py: 0.8,
            borderRadius: "999px",
            fontSize: 13,
            fontWeight: 900,
            boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
          }}
        >
          OptimizeXP Project
        </Box>
      </Box>

      <Box
        sx={{
          background: "rgba(255,255,255,0.94)",
          border: "1px solid rgba(0,120,201,0.13)",
          borderRadius: "32px",
          boxShadow: "0 18px 50px rgba(6,29,52,0.08)",
          p: { xs: 3, md: 5 },
          mb: 4,
        }}
      >
        <Box
          sx={{
            fontSize: { xs: 15, md: 17 },
            lineHeight: 1.9,
            color: "#334155",
            "& h1, & h2, & h3": {
              color: "#061d34",
              fontWeight: 900,
              marginTop: "28px",
            },
            "& p": {
              marginBottom: "18px",
            },
            "& img": {
              maxWidth: "100%",
              borderRadius: "22px",
              boxShadow: "0 14px 34px rgba(6,29,52,0.10)",
            },
            "& a": {
              color: "#0078c9",
              fontWeight: 800,
            },
          }}
          dangerouslySetInnerHTML={{ __html: project.content }}
        />
      </Box>

      <Box
        sx={{
          p: { xs: 2.5, md: 3 },
          borderRadius: "28px",
          background: "#061d34",
          color: "#fff",
          boxShadow: "0 20px 55px rgba(6,29,52,0.16)",
          mb: 4,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <Box>
          <Typography sx={{ fontSize: 20, fontWeight: 950 }}>
            Share this project
          </Typography>
          <Typography sx={{ color: "rgba(255,255,255,0.62)", fontSize: 13 }}>
            Share this project case study with your network
          </Typography>
        </Box>

        <Box sx={{ display: "flex", gap: 1 }}>
          {[
              {
  icon: <FacebookIcon />,
  url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
},
{
  icon: <TwitterIcon />,
  url: `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}`,
},
{
  icon: <LinkedInIcon />,
  url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`,
},
          ].map((item, index) => (
            <IconButton
              key={index}
              onClick={() =>   item.url}
              sx={{
                width: 44,
                height: 44,
                color: "#fff",
                background:
                  index % 2 === 0
                    ? "rgba(0,120,201,0.22)"
                    : "rgba(158,11,34,0.22)",
                border: "1px solid rgba(255,255,255,0.12)",
                "&:hover": {
                  background: index % 2 === 0 ? "#0078c9" : "#9e0b22",
                  transform: "translateY(-2px)",
                },
              }}
            >
              {item.icon}
            </IconButton>
          ))}
        </Box>
      </Box>

      <Box
        sx={{
          p: { xs: 3, md: 4 },
          borderRadius: "32px",
          background: "#fff",
          border: "1px solid rgba(0,120,201,0.14)",
          boxShadow: "0 18px 50px rgba(6,29,52,0.08)",
          mb: 4,
        }}
      >
        <Typography sx={{ color: "#061d34", fontSize: 26, fontWeight: 950, mb: 3 }}>
          Comments
        </Typography>

        {comments.length === 0 && (
          <Typography sx={{ color: "#64748b", fontSize: 14 }}>
            No comments yet. Be the first to share your thoughts.
          </Typography>
        )}

        <Box display="flex" flexDirection="column" gap={2}>
          {comments.map((c) => (
            <Box
              key={c._id}
              sx={{
                p: 2.5,
                borderRadius: "22px",
                background: "rgba(0,120,201,0.04)",
                border: "1px solid rgba(0,120,201,0.12)",
              }}
            >
              <Typography sx={{ fontWeight: 900, color: "#061d34", fontSize: 14 }}>
                {c.name}
              </Typography>

              <Typography sx={{ color: "#64748b", fontSize: 12 }}>
                {c.date}
              </Typography>

              <Typography sx={{ mt: 1.5, color: "#334155", fontSize: 14, lineHeight: 1.7 }}>
                {c.comment}
              </Typography>

              <Box sx={{ display: "flex", gap: 1, mt: 1.5 }}>
                <Button
                  size="small"
                  onClick={() => likeComment(c._id)}
                  sx={{
                    color: "#0078c9",
                    fontWeight: 800,
                    textTransform: "none",
                  }}
                >
                  👍 {c.likes}
                </Button>

                <Button
                  size="small"
                  onClick={() => setActiveReply(c._id)}
                  sx={{
                    color: "#9e0b22",
                    fontWeight: 800,
                    fontSize:12,
                    textTransform: "none",
                  }}
                >
                  Reply
                </Button>
              </Box>

              {activeReply === c._id && (
                <Box mt={2}>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Name"
                    value={replyName}
                    onChange={(e) => setReplyName(e.target.value)}
                    sx={fieldStyle}
                  />

                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Write a reply..."
                    value={replyText}
                    onChange={(e) => setReplyText(e.target.value)}
                    sx={fieldStyle}
                  />

                  <Button
                    size="small"
                    onClick={() => submitReply(c._id)}
                    sx={smallPrimaryBtn}
                  >
                    Post Reply
                  </Button>
                </Box>
              )}

              {c.replies &&
                c.replies.map((r) => (
                  <Box
                    sx={{
                      ml: { xs: 2, md: 5 },
                      mt: 2,
                      p: 2,
                      borderRadius: "18px",
                      background: "#fff",
                      border: "1px solid rgba(0,120,201,0.10)",
                    }}
                    key={r.id}
                  >
                    <Typography sx={{ fontWeight: 900, color: "#061d34", fontSize: 13 }}>
                      {r.name}
                    </Typography>

                    <Typography sx={{ color: "#64748b", fontSize: 11 }}>
                      {r.date}
                    </Typography>

                    <Typography sx={{ color: "#334155", fontSize: 13, mt: 1 }}>
                      {r.comment}
                    </Typography>
                  </Box>
                ))}
            </Box>
          ))}
        </Box>
      </Box>

      <Box
        sx={{
          p: { xs: 3, md: 4 },
          borderRadius: "32px",
          background: "#fff",
          border: "1px solid rgba(0,120,201,0.14)",
          boxShadow: "0 18px 50px rgba(6,29,52,0.08)",
        }}
      >
        <Typography sx={{ color: "#061d34", fontSize: 26, fontWeight: 950, mb: 3 }}>
          Leave a Comment
        </Typography>

        <TextField
          label="Name"
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
          sx={fieldStyle}
        />

        <TextField
          label="Email"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={fieldStyle}
        />

        <TextField
          label="Comment"
          fullWidth
          multiline
          rows={4}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          sx={fieldStyle}
        />

        <Button onClick={addComment} sx={primaryBtn}>
          Post Comment
        </Button>
      </Box>
    </Container>

    {loader ? <GlobalLoader /> : null}
  </Box>
);

}



const primaryBtn = {
  px: 3,
  py: 1.25,
  borderRadius: "999px",
  background: "linear-gradient(135deg, #0078c9, #005b98)",
  color: "#fff",
  fontWeight: 900,
  fontSize:14,
  textTransform: "none",
  boxShadow: "0 14px 34px rgba(0,120,201,0.28)",
  "&:hover": {
    background: "linear-gradient(135deg, #9e0b22, #75081a)",
    transform: "translateY(-2px)",
    boxShadow: "0 18px 40px rgba(158,11,34,0.28)",
  },
};

const smallPrimaryBtn = {
  mt: 1,
  px: 2.2,
  py: 0.8,
  borderRadius: "999px",
  background: "#0078c9",
  color: "#fff",
  fontWeight: 800,
  fontSize:14,
  textTransform: "none",
  "&:hover": {
    background: "#9e0b22",
  },
};

const fieldStyle = {
  mb: 2,
  "& .MuiOutlinedInput-root": {
    borderRadius: "16px",
    fontSize: "16px",
    "& fieldset": {
      borderColor: "rgba(0,120,201,0.16)",
    },
    "&:hover fieldset": {
      borderColor: "#0078c9",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#0078c9",
    },
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#0078c9",
  },
};

export default ProjectsPreview